var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChannelVimeo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 60,
  height: 52,
  viewBox: "0 0 60 52",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M2.437 17.323s5.026-3.935 6.701-1.967 8.07 25.722 10.205 30.104c1.864 3.843 7.003 8.923 12.64 5.295 5.633-3.628 24.365-19.514 27.718-38.274 3.35-18.753-22.542-14.825-25.284 1.514 6.854-4.088 10.513 1.661 7.006 8.17-3.502 6.502-6.701 10.743-8.377 10.743-1.672 0-2.958-4.351-4.874-11.957-1.98-7.863-1.968-22.026-10.202-20.42C10.205 2.044 0 14.149 0 14.149z"
})));
export default SvgChannelVimeo;